document.addEventListener('DOMContentLoaded', function() {
  const footerBlocks = document.querySelectorAll('.footer-nav-block');
  footerBlocks.forEach(block => {
    const heading = block.querySelector('div');
    const links = block.querySelector('.footer-nav-links');
    
    if (window.innerWidth <= 988) {
      links.style.maxHeight = '0px';
    }
    
    heading.addEventListener('click', function(e) {
      e.preventDefault();
      const isActive = block.classList.contains('active');
      footerBlocks.forEach(otherBlock => {
        if (otherBlock !== block) {
          otherBlock.classList.remove('active');
          const otherLinks = otherBlock.querySelector('.footer-nav-links');
          otherLinks.style.maxHeight = '0px';
        }
      });
    
      if (isActive) {
        block.classList.remove('active');
        links.style.maxHeight = '0px';
      } else {
        block.classList.add('active');
        links.style.maxHeight = links.scrollHeight + 'px';
      }
    });
  });
  
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      footerBlocks.forEach(block => {
        const links = block.querySelector('.footer-nav-links');
        if (window.innerWidth > 988) {
          links.style.maxHeight = 'none';
          block.classList.remove('active');
        } else {
          if (block.classList.contains('active')) {
            links.style.maxHeight = links.scrollHeight + 'px';
          } else {
            links.style.maxHeight = '0px';
          }
        }
      });
    }, 250);
  });
});